import fetcher from 'api/fetcher';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { setEfficiencyData, setLoadEfficiencyData } from 'store/models/efficiency';

export default () => {
    return (dispatch, getState) => {
        dispatch(setLoadEfficiencyData(true));
        const { from, to } = getState().efficiency;
        const queryStr = urlParser.stringify({
            dateFrom: formatDate(from),
            dateTo: formatDate(to),
        });
        return fetcher
            .get(`/api/v1/reports/efficiency?${queryStr}`)
            .then(({ efficiencyStatistics }) => {
                dispatch([setEfficiencyData(efficiencyStatistics), setLoadEfficiencyData(false)]);
            })
            .catch(() => {
                dispatch([setEfficiencyData({}), setLoadEfficiencyData(false)]);
            });
    };
};
